// src/utils/heartBeat.js

import { useEffect } from "react";
import { performRefresh } from "./refreshToken";
import { authStore } from "./tokenStore";
import { client } from "../apollo/client";

const devLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(...args);
  }
};

const HEARTBEAT_INTERVAL_MS = 60 * 1000; // every 1 minute
const REFRESH_BUFFER_SECONDS = 90; // refresh 90 sec before expiration

export function useAuthHeartbeat() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    devLog("🔥 Heartbeat mounted");
    const interval = setInterval(async () => {
      const auth = authStore.load();

      if (!auth?.jwtAuthExpiration || !auth?.authToken || !auth?.refreshToken) {
        return;
      }

      const now = Math.floor(Date.now() / 1000);
      const expiry = Number(auth.jwtAuthExpiration);

      const shouldRefresh = now >= expiry - REFRESH_BUFFER_SECONDS;

      if (shouldRefresh) {
        devLog("⏳ Heartbeat: token nearing expiration, refreshing...", {
          now,
          expiry,
          secondsLeft: expiry - now,
        });

        const refreshedToken = await performRefresh(client);

        if (refreshedToken) {
          devLog("💚 Heartbeat: token refreshed successfully");
        } else {
          devLog("💀 Heartbeat: refresh failed");
          // logout will be handled by retryRefreshLink if needed
        }
      }
    }, HEARTBEAT_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);
}
